import { createAction } from 'deox';

import { ResponseError } from 'modules/errors';

import {
  CreateArtworkQueryParams,
  CreateArtworkRequestBody,
  CreateArtworkResponse,
  Artwork,
  DeleteArtworkQueryParams,
  UpdateArtworkQueryParams,
} from 'types';

export const createArtwork = {
  request: createAction(
    'artwork/CREATE_ARTWORK',
    (resolve) => (
      requestBody: CreateArtworkRequestBody,
      requestParams: CreateArtworkQueryParams,
      onSuccess: () => void,
    ) => resolve({ requestBody, requestParams, onSuccess }),
  ),
  success: createAction(
    'artwork/CREATE_ARTWORK_SUCCESS',
    (resolve) => (payload: CreateArtworkResponse) => resolve(payload),
  ),
  fail: createAction('artwork/CREATE_ARTWORK_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const setArtwork = createAction(
  'artwork/SET_ARTWORK',
  (resolve) => (artwork: Artwork, previewMode: boolean) => resolve({ artwork, previewMode }),
);

export const deleteArtwork = {
  request: createAction(
    'artwork/DELETE_ARTWORK',
    (resolve) => (payload: DeleteArtworkQueryParams, onSuccess: () => void) =>
      resolve({ requestParams: payload, onSuccess }),
  ),
  success: createAction(
    'artwork/DELETE_ARTWORK_SUCCESS',
    (resolve) => (payload: DeleteArtworkQueryParams) => resolve(payload),
  ),
  fail: createAction('artwork/DELETE_ARTWORK_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const updateArtwork = {
  request: createAction(
    'artwork/UPDATE_ARTWORK',
    (resolve) => (
      requestBody: CreateArtworkRequestBody,
      requestParams: UpdateArtworkQueryParams,
      onSuccess: () => void,
    ) => resolve({ requestBody, requestParams, onSuccess }),
  ),
  success: createAction(
    'artwork/UPDATE_ARTWORK_SUCCESS',
    (resolve) => (payload: CreateArtworkResponse) => resolve(payload),
  ),
  fail: createAction('artwork/UPDATE_ARTWORK_FAIL', (resolve) => (error: ResponseError) =>
    resolve(error),
  ),
};

export const resetErrors = createAction('artwork/RESET_ERRORS', (resolve) => () => resolve());

export const resetArtwork = createAction('artwork/RESET_ARTWORK', (resolve) => () => resolve());
